import { useEffect, useState } from "react";

/**
 * Season, competition and team, persisted under the same `nw_dash_*` keys
 * Record (`Dashboard.jsx`) writes, so the Season chosen on Record is the
 * Season shown on the Dashboard (#1147, the drawing's "One Season filter").
 * Reads and writes are guarded: storage can be full or blocked.
 */
const read = (key) => {
  try {
    return localStorage.getItem(key) ?? "all";
  } catch {
    return "all";
  }
};
const write = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* quota / private mode */
  }
};

export function useDashFilters() {
  const [season, setSeason] = useState(() => read("nw_dash_season"));
  const [comp, setComp] = useState(() => read("nw_dash_comp"));
  const [team, setTeam] = useState(() => read("nw_dash_team"));
  useEffect(() => write("nw_dash_season", season), [season]);
  useEffect(() => write("nw_dash_comp", comp), [comp]);
  useEffect(() => write("nw_dash_team", team), [team]);
  return { season, comp, team, setSeason, setComp, setTeam };
}

/** `?season=…&competition=…&team=…`, omitting "all" (issues #55, #78). */
export function filterQuery({ season, comp, team }) {
  const params = new URLSearchParams();
  if (season !== "all") params.set("season", season);
  if (comp !== "all") params.set("competition", comp);
  if (team !== "all") params.set("team", team);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export default useDashFilters;
